/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Translation_FoundInputs */

const en_no_translation_found = /** @type {(inputs: No_Translation_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No translation found`)
};

const tr_no_translation_found = /** @type {(inputs: No_Translation_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çeviri bulunamadı`)
};

/**
* | output |
* | --- |
* | "No translation found" |
*
* @param {No_Translation_FoundInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const no_translation_found = /** @type {((inputs?: No_Translation_FoundInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Translation_FoundInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_translation_found(inputs)
	return tr_no_translation_found(inputs)
});